<!--
 * @Author: 李文敬
 * @version: 1.0.0
 * @Company: 和顺旭基(深圳)中医药科技有限公司
 * @Description:
 * @Date: 2021-08-17 10:19:07
 * @LastEditors: 李文敬
 * @LastEditTime: 2021-08-17 12:01:59
-->
<template>
  <div class="add-edit-dialog">
    <el-dialog
      width="800px"
      title="和顺堂12周年"
      :visible.sync="addEditDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="close"
      @closed="close"
    >
      <video-player
        ref="videoPlayer"
        class="video-player vjs-custom-skin"
        :playsinline="true"
        :options="playerOptions"
      />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 表单显示状态
      addEditDialog: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: 'https://wellsoon.cn/12years.mp4' // url地址
        }],
        hls: true,
        // poster: 'http://pic33.nipic.com/20131007/13639685_123501617185_2.jpg', // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 时间分割线
          durationDisplay: true, // 总时间
          remainingTimeDisplay: false, // 剩余播放时间
          progressControl: true, // 进度条
          fullscreenToggle: true // 全屏按钮
        }
      }
    }
  },
  methods: {
    // 打开时 执行以下方法
    open() {
      this.playerOptions.autoplay = true
      this.addEditDialog = true
      if (window.innerWidth <= 1024) {
        this.$nextTick(() => {
          const timer = setTimeout(() => {
            this.full(this.$refs.videoPlayer.player)
            clearTimeout(timer)
          }, 300)
          // this.$refs.videoPlayer.player.isFullscreen_ = true
        })
      }
    },
    // 初始化 数据
    close() {
      this.addEditDialog = false
      this.playerOptions = {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: 'https://wellsoon.cn/12years.mp4' // url地址
        }],
        hls: true,
        // poster: 'http://pic33.nipic.com/20131007/13639685_123501617185_2.jpg', // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 时间分割线
          durationDisplay: true, // 总时间
          remainingTimeDisplay: false, // 剩余播放时间
          progressControl: true, // 进度条
          fullscreenToggle: true // 全屏按钮
        }
      }
    },
    full(element) {
      // 做兼容处理
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen()
      } else {
        var docHtml = document.documentElement
        var docBody = document.body
        var videobox = document.getElementsByClassName('video-player')
        var cssText = 'width:100%;height:100%;overflow:hidden;'
        docHtml.style.cssText = cssText
        docBody.style.cssText = cssText
        videobox.style.cssText = cssText + ';' + 'margin:0px;padding:0px;'
        document.IsFullScreen = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.addEdit {
  display: block;
}
/deep/ .el-dialog {
  margin-top: 5vh !important;
  width: 75vw !important;
}
/deep/ .el-dialog__header {
  padding: 0;
  height: 0;
  .el-dialog__headerbtn {
    font-size: 20px;
    z-index: 99;
  }
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/ .vjs-big-play-button{
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/view/components/videoDialog.vue